import { render } from "./InputFormContactPersonModal.vue?vue&type=template&id=4a7d2e4c"
import script from "./InputFormContactPersonModal.vue?vue&type=script&lang=ts"
export * from "./InputFormContactPersonModal.vue?vue&type=script&lang=ts"
script.render = render

export default script